import Vue from 'vue';
// import VueAnalytics, { event } from 'vue-analytics';
import VueTheMask from 'vue-the-mask';
import App from './App.vue';
import api from './api';
import './filters';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

import { omit } from 'lodash';

import '@/components/common';
import '@/components/modules';

Vue.config.productionTip = false;

Vue.prototype.$api = api;

// Vue.use(VueAnalytics, {
//   id: 'TODO',
//   router,
//   debug: {
//     sendHitTask: !/localhost/i.test(window.location.hostname)
//   }
// });

// Vue.directive('track', (el, binding) => {
//     el.onclick = () => {
//         if ('A' === el.tagName && el.href) {
//             event(binding.value?.category || 'Link', binding.value?.action || 'click', binding.value?.label || el.href, binding.value?.value);
//         } else if (binding.value?.category && binding.value?.action && binding.value?.label) {
//             event(binding.value?.category, binding.value?.action, binding.value?.label, binding.value?.value);
//         }
//     };
// });

Vue.use(VueTheMask);

router.afterEach(async (to, from) => {
    let isFinishing = false;
    if (store.get('allComplete') && !store.get('finished')) {
        store.set('finished', true);
        isFinishing = true;
    }

    try {
        await api.post('/state', { data: omit(store.state, ['user']), isFinishing });
    } catch (error) {
        // nothing
    }
});

async function init() {
    if (!/\/login/.test(window.location.href)) {
        try {
            const remoteState = await api.get('/state');
            if (remoteState && remoteState.data && remoteState.data.state) {
                store.commit('loadState', remoteState.data.state.data);
                const remotePhoto = await api.get('/photo');
                if (remotePhoto && remotePhoto.data && remotePhoto.data.photo) {
                    store.set('photo', remotePhoto.data.photo.src);
                }
            }
        } catch (err) {
            // nothing
        }
    }

    new Vue({
        router,
        store,
        vuetify,
        render: (h) => h(App)
    }).$mount('#app');
}
init().then(() => {});
